import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from 'data/api/base';

export function useGetRevendaDesempenhoExcel() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getRevendaDesempenhoExcel = useCallback(
        (anoMesApuracao: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/resultados/revendas-desempenho/apuracao-excel/${anoMesApuracao}?${query || ''}`,
                method: 'GET',
                enviarTokenUsuario: true,
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    "Content-Disposition": "attachment; filename=Comissoes.xls; filename*=UTF-8''Comissoes.xls"
                },
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getRevendaDesempenhoExcel,
    };
}
